import { cn } from "@/lib/utils"

// The card chrome every order-detail panel sits in (design prototype `.card` /
// `.card-head` / `.card-pad`). Shared because all seven panels repeat it.
export function PanelCard({ className, children }) {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-2xl border border-border bg-card",
        className
      )}
    >
      {children}
    </div>
  )
}

// Below 720 the head wraps rather than squeezing its trailing slot (a status
// pill, a "Designed by …" byline), and any cluster the panel puts in that slot
// wraps with it.
//
// ABOVE 720 THE HEAD DOES NOT WRAP, and the trailing slot is where a person's
// NAME goes ("Illustrated by …", "Designed by …"). A name is one or two
// unbreakable tokens: normal wrapping can only break at the space between them,
// so the widest token is a hard floor on how narrow the slot can get, and past
// that the name simply paints outside the card's `overflow-hidden` edge.
// Measured with a 21-character token, at the widths where the order page's tab
// rail has already squeezed the panel column: 80px past the card at 861 and
// 41px at 900. `min-width:0` does NOT help — releasing the flex item's
// automatic minimum shrinks its BOX while the text inside keeps the same floor
// and overflows it (measured: the overflow stays at exactly 80/41). Nor does
// `break-words`: `overflow-wrap:break-word` breaks a word only once the line is
// already too short, and does not reduce min-content, which is what the floor
// is made of.
//   `overflow-wrap:anywhere` is the one treatment that does reduce it, so the
// name wraps INSIDE the card instead of past it, with every character still on
// screen — no ellipsis, nothing hidden. It is also what this app already does
// with freelancer names in a tight box (components/tuw/hire/FreelancerRow.jsx
// :145/:151). It costs nothing where the slot is not starved: with a real name
// the head height, slot width and line breaks are identical at every width.
export function PanelCardHead({ Icon, title, children }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-border px-[22px] py-4 [&>*+*]:[overflow-wrap:anywhere] max-[720px]:flex-wrap max-[720px]:gap-2.5 max-[720px]:px-4 max-[720px]:py-[13px] max-[720px]:[&>div]:flex-wrap">
      <h3 className="flex items-center gap-[9px] font-display text-[14.5px] font-bold">
        {Icon && <Icon className="size-[17px] text-primary" strokeWidth={1.9} />}
        {title}
      </h3>
      {children}
    </div>
  )
}

export function PanelCardBody({ className, children }) {
  return (
    <div className={cn("px-[22px] py-5 max-[720px]:px-[14px] max-[720px]:py-4", className)}>
      {children}
    </div>
  )
}
